import antdSA from 'antd/lib/locale-provider/en_US';
import appLocaleData from 'react-intl/locale-data/fa';
import faMessages from '../locales/fa_IR.json';
import enumMessages from '../locales/enum.fa_IR.json';
import errorMessages from '../locales/error.fa_IR.json';

const faLang = {
  messages: {
    ...faMessages,
    ...enumMessages,
    ...errorMessages

  },
  antd: antdSA,
  locale: 'fa',
  data: appLocaleData
};
export default faLang;
